import type { FaireProductEntity } from "../../entity_types/product";

export const p_k3dyn8wr2j: FaireProductEntity = {
  token: "p_k3dyn8wr2j",
  type: "product",
  name: "Organic Blue Vervain Loose Leaf Tea",
  brandToken: "b_bqcgv7uqrr",
  brandName: "Healing Herbals",
  imageUrl:
    "https://cdn.faire.com/fastly/45dac8788f368d2a0721be00dc58af904117537237219aa62d20973ce7802c25.jpeg",
  galleryImageUrls: [],
  priceDollars: 25.04,
  description:
    "\nBlue Vervain Loose Leaf Tea\n\nDiscover the natural tranquility of Blue Vervain Loose Leaf Tea from Healing Herbals. Sourced from the finest Blue Vervain (Verbena officinalis), a herb celebrated for its calming properties and historical medicinal use, this tea offers a serene sipping experience. Ideal for those seeking to unwind and de-stress, our Blue Vervain Tea is a gentle, herbal beverage choice.\n\nProduct Highlights:\n\n * Ingredients: 100% pure Blue Vervain leaves \n * Benefits: Supports relaxation, eases tension, and promotes a calming effect \nBrewing Instructions: Steep one teaspoon of loose leaf tea in hot water for 5-10 minutes. Adjust the amount or brewing time according to taste preference.",
  tags: [],
  msrpDollars: 31.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:54.267Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
